import {PackageStruct} from './PackingRuleStruct.js';

export default {
    data() {
        return {
            originalBoxes: [],
        }
    },

    mounted() {
        // make a copy of the original boxes by creating a new instance of the PackageStruct
        this.originalBoxes = this.boxes.map(box => new PackageStruct(box));
    },

    methods: {
        onAdd() {
            this.boxes.push(new PackageStruct({packing_rule_id: this.formData.id}));

            this.$nextTick(() => {
                const virtualScroll = this.$refs.virtualScroll.$el;
                virtualScroll.scrollTop = virtualScroll.scrollHeight;
            });

            this.$emit('validation-state', false);
        },

        onRemove(index) {
            this.addPackageToDeleteList(this.boxes[index]);
            this.boxes.splice(index, 1)
            this.validate();
        },

        // this is executed once user imports packages from the CSV file
        // so we need to clear the existing packages and add the new ones
        // this would also mean deleting the existing packages from the database
        updatePackages(packageSettings) {

            if(this.originalBoxes.length > 0) {
                // get all the box ids and add them to the delete list
                const boxIds = this.originalBoxes.map(box => box.id);
                this.$emit('add-package-to-delete-list', boxIds);
            }

            this.boxes.length = 0; //Truncates the array to 0 items, effectively clearing it.
            this.boxes.push(...packageSettings);
            this.$emit('scroll-bottom');
        },

        addPackageToDeleteList(pkg) {
            if(pkg.id != null) {
                this.$emit('add-package-to-delete-list', pkg.id);
            }
        }
    }
}